import React, {createContext, useReducer} from 'react'
import {LidarTesterReducer} from "../reducer/LidarTesterReducer";

export const LidarTesterContext = createContext();

const LidarTesterContextProvider = (props) => {
    const data = {
        controllerMacAddress: null,
        columnsList: [],
        sensorStateMap: {},
    }
    const [testerViewModel, testerDispatch] = useReducer(LidarTesterReducer, data)
    return (
        <LidarTesterContext.Provider value={{testerViewModel, testerDispatch}}>
            {props.children}
        </LidarTesterContext.Provider>
    )
}

export default LidarTesterContextProvider



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/context/LidarTesterContext.js